import { graphql, type ResultOf } from "src/gql/graphql";

const KarteConfigFragment = graphql(
  `
  fragment KarteConfig on KarteConfig @_unmask {
    id
    honorificType
  }
  `,
);

export const WorkspaceGlobalsFragment = graphql(
  `
  fragment WorkspaceGlobals on Workspace @_unmask {
    id
    karteConfig {
      ...KarteConfig
    }
    activeCustomerVisitFieldsSchema {
      id
      schema
    }
  }
`,
  [KarteConfigFragment],
);

type KarteConfig = ResultOf<typeof KarteConfigFragment>;

export type HonorificType = "Sama" | "Goryoke";

type CustomerVisitFieldsSchema = {
  schema: unknown;
};

export type ValidatedWorkspaceGlobals = {
  id: string;
  karteConfig: KarteConfig | null;
  activeCustomerVisitFieldsSchema: CustomerVisitFieldsSchema | null;
};
